import {
  isWilsonBrand,
  WilsonFullLogo,
  wilsonLoginGradient,
} from '../../wilson-brand';
import LoginForm from '../components/login-form';
import { ThemeModeProvider } from '../components/theme/theme';
import { ThemeLayout } from '../components/theme/theme-layout';
import styles from './login.module.css';

const LOGO_HEIGHTS = ['18px', '18px', '18px', '24px'];
const LOGO_WIDTHS = ['158px', '158px', '158px', '165px'];

function Login() {
  if (isWilsonBrand) {
    return (
      <div
        className={styles.wilsonShell}
        // The gradient is built from the Wilson palette in JS, so it comes in
        // as a custom property rather than living in the stylesheet.
        style={
          {
            '--ap-wilson-login-gradient': wilsonLoginGradient,
          } as React.CSSProperties
        }
      >
        <div className={styles.wilsonLogo}>
          <WilsonFullLogo
            viewBox="34 0 51 13"
            height={LOGO_HEIGHTS}
            width={LOGO_WIDTHS}
          />
        </div>
        {/* Wilson keeps its own logo + light gradient (no hero); the form
            renders the themed controls, always in light mode since the
            gradient is white-based. */}
        <div className={styles.wilsonBody}>
          <ThemeModeProvider value="light">
            <div className={styles.wilsonForm}>
              <LoginForm />
            </div>
          </ThemeModeProvider>
        </div>
      </div>
    );
  }

  return (
    <ThemeLayout>
      <LoginForm />
    </ThemeLayout>
  );
}

export default Login;
